<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="table-container" *ngIf="activityData">
  <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
    <div class="">
      <div class="search-container">
        <span class="fa fa-search form-control-feedback"></span>
        <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
          [(ngModel)]="searchValue">
      </div>
    </div>

    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="message.dataGridAdmin"
      (click)="openReorder()" (keydown.enter)="openReorder()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
        <path style="fill:'#FFFFFF'"
          d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
      </svg>
      <span class="reload_text text-white">Settings</span>
    </div>

    <div class="">
      <div class="action-buttons-container d-flex gap-2">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.showActionsActionButtons" (click)="openAddPopup()" (keydown.enter)="openAddPopup()"
          matTooltip="Add Actions">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (keydown.enter)="openReport('Pdf')" (click)="openReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div>
          <span class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openReorderPopup()" (keydown.enter)="openReorderPopup()" matTooltip="Reorder"
            *ngIf="grid?.length > 1">
            <img src="../../../assets/img/reorder.svg" width="18px" height="18px" alt="reorder" />
            <span class="reload_text text-white">Reorder</span>
          </span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (keydown.enter)="openAuditTrail('overAll',0)"
          (click)="openAuditTrail('overAll',0)">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshGridData()" (keydown.enter)="refreshGridData()" matTooltip="Refresh Grid">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>

  <table class="dynamic-table-container">
    <th style="min-width: 60px; text-align: center;"
      [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
      <div style="display: flex;">
        <div>
          <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
        </div>
      </div>
    </th>
    <th id="grid-header-container" class="sticky-dynamic-col1"
      *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
      [ngStyle]="{'min-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200,'max-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200}">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>{{taskDocumentsDataForGridData.fieldColumnarray}}</span>
      </div>
    </th>
    <th id="menu" class="sticky-col first-col-Action"></th>
    <tr>
      <td [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''"></td>
      <td class="sticky-dynamic-col1"
        *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
        [ngStyle]="{'min-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200,'max-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200}">
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="columnFilter(columnLists.columnsListarray[ix],$event)">
        </div>
      </td>
    </tr>
    <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
      [class.highlightRow]="list.childCheckBoxs == true">
      <td style="min-width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
              (change)="onChildChanged($event, list, idx)">
          </div>
        </div>
      </td>
      <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
        class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width !=null ? key.width :200,'max-width': key.width !=null ? key.width :200,'overflow': 'hidden',
      'text-overflow': 'ellipsis',
      'white-space': 'nowrap'}" (mouseover)="cssFunction(i)" (click)="openEditPopup(list,i)"
        (keydown.enter)="openEditPopup(list,i)" (focus)="focus()">
        <span *ngIf="key.dataType=='CHECKBOX'">
          <div class="gridCheckBoxes">
            <img *ngIf="list[key.columnsListarray]" src="../../../assets/img/cr_module/accessSymbol.svg" width="16"
              height="16" alt="access" />
            <img *ngIf="list[key.columnsListarray] == false" src="../../../assets/img/cr_module/noAcessSymbol.svg"
              width="16" height="16" alt="no access" />
          </div>
        </span>

        <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
              (click)="getClobData(list,key.columnsListarray)">
              <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
              <span class="ms-1">View</span>
            </button>
          </div>
        </span>

        <span
          *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' && key.columnsListarray !='NO_OF_EXTENSIONS_REQUESTED'">
          {{ list[key.columnsListarray] }}</span>
        <span *ngIf="key.columnsListarray=='NO_OF_EXTENSIONS_REQUESTED'" (click)="openDynamicGrid(list)"
          (keydown.enter)="openDynamicGrid(list)">
          <a style="color: blue !important;text-decoration: underline !important;">{{ list[key.columnsListarray] }}</a>
        </span>
        <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
      </td>
      <td class="sticky-col first-col">
        <div class="action-icons">
          <span *ngIf="message.showActionsActionButtons">
            <i class="fa-solid fa-pencil" matTooltip="Edit Actions" style="margin-left: 5px;"
              (click)="openEditPopup(list,0)" (keydown.enter)="openEditPopup(list,0)"></i>
          </span>
          <i class="fa-solid fa-clipboard" *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail"
            style="margin-left: 5px;" (click)="openAuditTrail('individual',list)"
            (keydown.enter)="openAuditTrail('individual',list)"></i>
        </div>
      </td>
    </tr>
  </table>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span></label>
    </div>
    <div class="frozen-popup-content">
      <div class="row">
        <div class="col-md-4">
          <div class="row" style="line-height: 23px;" *ngIf="this.qmsservice.moduleName=='CR'">
            <div class="col-sm-5"> <label for="email"> <b>Change Request ID :</b> </label> </div>
            <div class="col-sm-7" style="padding-left: 20px;">
              <span class="tooltip-style" matTooltip="{{this.qmsservice.activity.crId}}">
                {{this.qmsservice.activity.crId}}
              </span>
            </div>
          </div>
          <div class="row" style="line-height: 23px;" *ngIf="this.qmsservice.moduleName=='CAPA'">
            <div class="col-sm-5"> <label for="email"> <b>CAPA ID :</b> </label> </div>
            <div class="col-sm-7" style="padding-left: 20px;">
              <span class="tooltip-style" matTooltip="{{this.qmsservice.activity.capaId}}">
                {{this.qmsservice.activity.capaId}}
              </span>
            </div>
          </div>
          <div class="row" style="line-height: 23px;" *ngIf="this.qmsservice.moduleName=='DV'">
            <div class="col-sm-5"> <label for="email"> <b>Deviation ID :</b> </label> </div>
            <div class="col-sm-7" style="padding-left: 20px;">
              <span class="tooltip-style" matTooltip="{{this.qmsservice.activity.dvId}}">
                {{this.qmsservice.activity.dvId}}
              </span>
            </div>
          </div>
          <div class="row" style="line-height: 23px;" *ngIf="this.qmsservice.moduleName=='IN'">
            <div class="col-sm-5"> <label for="email"> <b>Incident ID :</b> </label> </div>
            <div class="col-sm-7">
              <span class="tooltip-style" matTooltip="{{this.qmsservice.activity.inId}}">
                {{this.qmsservice.activity.inId}}
              </span>
            </div>
          </div>
          <div class="row" style="line-height: 23px;" *ngIf="this.qmsservice.moduleName=='QI'">
            <div class="col-sm-5"> <label for="email"> <b>Quality Issue ID :</b> </label> </div>
            <div class="col-sm-7">
              <span class="tooltip-style" matTooltip="{{this.qmsservice.activity.qiId}}">
                {{this.qmsservice.activity.qiId}}
              </span>
            </div>
          </div>
          <div class="row" style="line-height: 23px;" *ngIf="this.qmsservice.moduleName=='CC'">
            <div class="col-sm-5"> <label for="email"> <b>Complaint ID :</b> </label> </div>
            <div class="col-sm-7">
              <span class="tooltip-style" matTooltip="{{this.qmsservice.activity.ccId}}">
                {{this.qmsservice.activity.ccId}}
              </span>
            </div>
          </div>
          <div class="row" style="line-height: 23px;">
            <div class="col-sm-5">
              <label for="email" *ngIf="this.qmsservice.moduleName=='CR'"><b>Change Request Status :</b> </label>
              <label for="email" *ngIf="this.qmsservice.moduleName=='CAPA'"><b>CAPA Status :</b> </label>
              <label for="email" *ngIf="this.qmsservice.moduleName=='DV'"><b>Deviation Status :</b> </label>
              <label for="email" *ngIf="this.qmsservice.moduleName=='IN'"><b>Incident Status :</b> </label>
              <label for="email" *ngIf="this.qmsservice.moduleName=='QI'"><b>Quality Issue Status :</b> </label>
              <label for="email" *ngIf="this.qmsservice.moduleName=='CC'"><b>Complaint Status :</b> </label>
            </div>
            <div class="col-sm-7" style="padding-left: 10px;">{{this.qmsservice.activity.status }}</div>
          </div>
          <div class="row" style="line-height: 23px;"
            *ngIf="this.qmsservice.moduleName=='CR' || this.qmsservice.moduleName=='CAPA' || this.qmsservice.moduleName=='DV' ">
            <div class="col-sm-5"><label
                for="email"><b>{{qmsservice.activityDynamicLabel?.['OWNER_USER_NAME']?.fieldName ?? 'Owner'}} :</b>
              </label></div>
            <div class="col-sm-7" style="padding-left: 20px;">{{this.qmsservice.activity.ownerUserName}}
            </div>
          </div>
          <div class="row" style="line-height: 23px;"
            *ngIf="this.qmsservice.moduleName=='IN' || this.qmsservice.moduleName=='QI' || this.qmsservice.moduleName=='CC' ">
            <div class="col-sm-5"><label for="email"><b>{{qmsservice.activityDynamicLabel?.['EVALUATOR_USER']?.fieldName
                  ?? 'Evaluator'}} :</b> </label></div>
            <div class="col-sm-7">{{this.qmsservice.activity.evaluatorUser}}</div>
          </div>
          <div class="row" style="line-height: 23px;">
            <div class="col-sm-5" style="width: 42%;">
              <label for="email">
                <b>{{qmsservice.activityDynamicLabel?.['EXPCETED_CLOSURE_ON']?.fieldName ?? 'Expected Closure Date'}}
                  :</b>
              </label>
            </div>
            <div class="col-sm-6">{{this.qmsservice.activity.expcetedClosureOn | date : appService.getOneQmsDateFormat}}
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row" *ngIf="this.qmsservice.moduleName=='CR'">
            <div>
              <label for="email"> <b>
                  {{qmsservice.activityDynamicLabel?.['CURRENT_STATE']?.fieldName ?? 'Current State'}} :
                </b> </label>
            </div>
            <div class="row d-flex align-items-center">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qmsservice.activity.currentState" [config]="config"
                  style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Current State', 'eye','activity')"
                (keydown.enter)="openEditor('Current State', 'eye','activity')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="this.qmsservice.moduleName=='CAPA'">
            <div><label for="email"><b>{{qmsservice.activityDynamicLabel?.['CAPA_DESCRIPTION']?.fieldName ??
                  'CAPA Description'}}:</b> </label></div>
            <div class="row d-flex align-items-center">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qmsservice.activity.capaDescription" [config]="config"
                  style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit" (click)="openEditor('CAPA Description', 'eye','activity')"
                (keydown.enter)="openEditor('CAPA Description', 'eye','activity')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="this.qmsservice.moduleName=='DV'">
            <div><label for="email"><b>{{qmsservice.activityDynamicLabel?.['DV_DESCRIPTION']?.fieldName ??
                  'Deviation Description'}}:</b> </label></div>
            <div class="row d-flex align-items-center">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qmsservice.activity.dvDescription" [config]="config"
                  style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Deviation Description', 'eye','activity')"
                (keydown.enter)="openEditor('Deviation Description', 'eye','activity')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="this.qmsservice.moduleName=='IN' || this.qmsservice.moduleName=='QI'">
            <div><label for="email"><b>{{qmsservice.activityDynamicLabel?.['DESCRIPTION']?.fieldName ??
                  'Description'}}:</b> </label></div>
            <div class="row d-flex align-items-center">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qmsservice.activity.description" [config]="config"
                  style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Description', 'eye','activity')"
                (keydown.enter)="openEditor('Description', 'eye','activity')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="this.qmsservice.moduleName=='CC'">
            <div><label for="email"><b>{{qmsservice.activityDynamicLabel?.['COMPLAINT_DESCRIPTION']?.fieldName ??
                  'Complaint Description'}}:</b> </label></div>
            <div class="row d-flex align-items-center">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qmsservice.activity.complaintDescription" [config]="config"
                  style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Complaint Description', 'eye','activity')"
                (keydown.enter)="openEditor('Complaint Description', 'eye','activity')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row" *ngIf="this.qmsservice.moduleName=='CR'">
            <div><label for="email"><b>{{qmsservice.activityDynamicLabel?.['PROPOSED_CHANGE']?.fieldName ??
                  'Proposed Change'}}:</b> </label></div>
            <div class="row d-flex align-items-center">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qmsservice.activity.proposedChange" [config]="config"
                  style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Proposed Change', 'eye','activity')"
                (keydown.enter)="openEditor('Proposed Change', 'eye','activity')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="this.qmsservice.moduleName=='CAPA'">
            <div><label for="email"><b> {{qmsservice.activityDynamicLabel?.['INVESTIGATION_SUMMARY']?.fieldName ??
                  'Investigation Summary'}}:</b> </label></div>
            <div class="row d-flex align-items-center">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qmsservice.activity.investigationSummary" [config]="config"
                  style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Investigation Summary', 'eye','activity')"
                (keydown.enter)="openEditor('Investigation Summary', 'eye','activity')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="this.qmsservice.moduleName=='IN' || this.qmsservice.moduleName=='QI'">
            <div><label for="email"><b>{{qmsservice.activityDynamicLabel?.['IMPACT_DESCRIPTION']?.fieldName ??
                  'Impact Description'}}:</b> </label></div>
            <div class="row d-flex align-items-center">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qmsservice.activity.impactDescription" [config]="config"
                  style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Impact Description', 'eye','activity')"
                (keydown.enter)="openEditor('Impact Description', 'eye','activity')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="this.qmsservice.moduleName=='CC'">
            <div><label for="email"><b>{{qmsservice.activityDynamicLabel?.['INITIAL_ASSESSMENT']?.fieldName ??
                  'Initial Assessment'}}:</b> </label></div>
            <div class="row d-flex align-items-center">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qmsservice.activity.initialAssessment" [config]="config"
                  style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Initial Assessment', 'eye','activity')"
                (keydown.enter)="openEditor('Initial Assessment', 'eye','activity')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr style="color: #cfcfcf;">

    <div style="max-height: 400px; overflow-y: scroll; overflow-x: hidden; margin: 15px;">
      <div class="row">
        <div class="col-md-2" *ngIf="visibleEditButton">
          <div>
            <label for="email">{{dynamicLabel['STATUS'].fieldName}}</label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['STATUS'].fieldNotes"
              [matTooltip]="dynamicLabel['STATUS'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <input class="input-filed-continers" type="text" placeholder="" [(ngModel)]="action.status" disabled>
        </div>
        <div class="col-md-3">
          <div> <!-- Action Name -->
            <label id="actionName-validation" for="email"> {{dynamicLabel['ACTION_NAME'].fieldName}} </label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['ACTION_NAME'].fieldNotes"
              [matTooltip]="dynamicLabel['ACTION_NAME'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <input class="input-filed-continers" type="text" placeholder="" [(ngModel)]="action.actionName"
            (focusout)="onFieldFocusout()" [disabled]="qmsservice.activity.status=='In Progress'">
        </div>
        <div class="col-md-3" *ngIf="dynamicLabel['ACTION_TYPE'].isRemovable != 'Y' && qmsservice.moduleName =='CAPA'">
          <div> <!-- Action At -->
            <label id="action-type" for="email"> {{dynamicLabel['ACTION_TYPE'].fieldName}} </label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['ACTION_TYPE'].fieldNotes"
              [matTooltip]="dynamicLabel['ACTION_TYPE'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <mat-select matInput multiple #actionType placeholder="Select" [(ngModel)]="selectedActionType"
            (closed)="searchTypeText=''" [disabled]="qmsservice.activity.status=='In Progress'"
            (click)="focusmethod('focusSearch')" (keydown.enter)="focusmethod('focusSearch')">
            <input type="search" id="focusSearch" class="dropdownsearchstyle" [(ngModel)]="searchTypeText" matInput
              placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isAllActionTypeSelected" (change)="toggleAllSelection('actionType')">
                Select All
              </mat-checkbox>
            </div>
            <mat-option *ngFor="let item1 of dropDownForActionType | multiAssessmentSearchPipe :searchTypeText"
              [value]="item1.valueExp" (onSelectionChange)="onActionTypeSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-4" [hidden]="dynamicLabel['ACTION_DESCRIPTION'].isRemovable == 'Y'">
          <div>
            <label for="email">
              {{ dynamicLabel['ACTION_DESCRIPTION'].fieldName }}
            </label>
            <span style="float:right" *ngIf="dynamicLabel['ACTION_DESCRIPTION'].fieldNotes"
              [matTooltip]="dynamicLabel['ACTION_DESCRIPTION'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>

          <div class="row d-flex align-items-center">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="action.actionDescription" [config]="config" style="min-height: 100px !important;"
                [spellcheck]="true" [disabled]="qmsservice.activity.status == 'In Progress'" (paste)="onPaste($event)">
              </st-editor>
            </div>
            <div *ngIf="qmsservice.activity.status !== 'In Progress'" class="col-sm-1 angular-editor-edit"
              (click)="openEditor('Action Description', 'edit','action')"
              (keydown.enter)="openEditor('Action Description', 'edit','action')">
              <i class="far fa-edit"></i>
            </div>
            <div *ngIf="qmsservice.activity.status == 'In Progress'" class="col-sm-1 angular-editor-edit"
              (click)="openEditor('Action Description', 'eye','action')"
              (keydown.enter)="openEditor('Action Description', 'eye','action')">
              <i class="fa fa-eye eye"></i>
            </div>
          </div>
        </div>

        <div class="col-md-2" *ngIf="action.createdOn">
          <label id="actionCreatedOn-validation" for="email"> {{dynamicLabel['CREATED_ON'].fieldName}}
          </label>
          <span style="float:right" *ngIf="dynamicLabel['CREATED_ON'].fieldNotes"
            [matTooltip]="dynamicLabel['CREATED_ON'].fieldNotes">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
          </span>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="$dateTimeConfig"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="action.createdOn" [disabled]="true">
        </div>
        <div class="col-md-2">
          <div><!-- Target Date -->
            <label id="targetDate-validation" for="email"> {{dynamicLabel['TARGET_DATE'].fieldName}} </label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['TARGET_DATE'].fieldNotes"
              [matTooltip]="dynamicLabel['TARGET_DATE'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="$targetDateConfig"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="action.targetDate"
            (ngModelChange)="changeExpcetedClosureOnDate($event)"
            [disabled]="qmsservice.activity.status=='In Progress'">
        </div>
        <div class="col-md-4" [hidden]="dynamicLabel['ACTION_AT'].isRemovable == 'Y' || qmsservice.moduleName =='CC'">
          <div> <!-- Action At -->
            <label id="activityAt-validation" for="email"> {{dynamicLabel['ACTION_AT'].fieldName}} </label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['ACTION_AT'].fieldNotes"
              [matTooltip]="dynamicLabel['ACTION_AT'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="searchingByRequestedAt" (closed)="requestedAtTxt=''"
            (click)="focusmethod('requestedAtSearch')" (keydown.enter)="focusmethod('requestedAtSearch')"
            [disabled]="qmsservice.activity.status=='In Progress'"
            [ngClass]="{'odd-item-mat-select':isrequestedAtOdd==searchingByRequestedAt}">
            <input type="search" id="requestedAtSearch" class="dropdownsearchstyle" [(ngModel)]="requestedAtTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onRequestedAtSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of RequestedAtDropdown| assessmentSearch :requestedAtTxt"
              (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-4" [hidden]="dynamicLabel['ACTION_AT'].isRemovable == 'Y' || qmsservice.moduleName =='CC'"
          [matTooltip]="coreBusinessAreaNameValue">
          <div>
            <label id="coreBusinessAreaNameValue-validation" for="email">
              {{((this.bussinessAreaName ?? '') + ' ' + dynamicLabel['CORE_BUSINESS_AREA'].fieldName)}}
            </label>
            <span class="mandatory-symbol">*</span>
          </div>
          <mat-select matInput multiple #coreBusinessAreaName placeholder="Select"
            *ngIf="coreBusinessAreaNameDropdown.length>0" [(ngModel)]="coreBusinessAreaNameValue"
            (closed)="coreBusinessAreaNameTxt=''" [disabled]="qmsservice.activity.status=='In Progress'"
            (click)="focusmethod('c-b-a')" (keydown.enter)="focusmethod('c-b-a')">
            <input type="search" id="c-b-a" class="dropdownsearchstyle" [(ngModel)]="coreBusinessAreaNameTxt" matInput
              placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="coreBusinessAreaNameSelected"
                (change)="toggleAllSelection('coreBusinessAreaName')">Select All</mat-checkbox>
            </div>
            <mat-option
              *ngFor="let item1 of coreBusinessAreaNameDropdown| multiAssessmentSearchPipe :coreBusinessAreaNameTxt"
              [value]="item1.valueExp" (onSelectionChange)="onCoreBusinessAreaNameSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
            *ngIf="coreBusinessAreaNameDropdown.length==0" [(ngModel)]="coreBusinessAreaNameValue"></textarea>
        </div>
        <div class="col-md-4" id="search-container">
          <div><!-- Assigned To -->
            <label id="assignedTo-validation" for="email"> {{dynamicLabel['ASSIGNED_TO'].fieldName}} </label>
            <span class="mandatory-symbol">*</span>
            <label *ngIf="message.showSwitchUser && getSwitchUser('assign-to')" id="owner-validation" for="email"
              (click)="searchAssignTo('switch')" (keydown.enter)="searchAssignTo('switch')">
              <a>
                <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Yes" width="25" height="25">
              </a>
            </label>
            <span style="float:right" *ngIf="dynamicLabel['ASSIGNED_TO'].fieldNotes"
              [matTooltip]="dynamicLabel['ASSIGNED_TO'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <div style="display: flex; justify-content: center;">
            <div class="col-sm-11" style="position: relative;">
              <input id="participantUserName" class="input-filed-continers" style="cursor: not-allowed;" type="text"
                [(ngModel)]="action.assignedTo" disabled>
            </div>
            <div class="col-sm-1" style="padding-left: 2%; cursor: pointer;" (click)="searchAssignTo('search')"
              (keydown.enter)="searchAssignTo('search')" *ngIf="qmsservice.activity.status != 'In Progress'">
              <i class="fa fa-search"></i>
            </div>
          </div>
        </div>
        <div class="col-md-4" [hidden]="dynamicLabel['ASSIGNED_TO_DEPARTMENT'].isRemovable == 'Y'">
          <div><!-- Department -->
            <label for="email"> {{dynamicLabel['ASSIGNED_TO_DEPARTMENT'].fieldName}} </label>
            <span style="float:right" *ngIf="dynamicLabel['ASSIGNED_TO_DEPARTMENT'].fieldNotes"
              [matTooltip]="dynamicLabel['ASSIGNED_TO_DEPARTMENT'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode" (closed)="departmentCodeTxt=''"
            (click)="focusmethod('departmentCodeSearch')" [disabled]="qmsservice.activity.status=='In Progress'"
            [ngClass]="{'odd-item-mat-select':isdepartmentCodeOdd==searchByDepartmentCode}"
            (keydown.enter)="focusmethod('departmentCodeSearch')">
            <input type="search" id="departmentCodeSearch" class="dropdownsearchstyle" [(ngModel)]="departmentCodeTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of departmentCodeDropdown| assessmentSearch :departmentCodeTxt"
              (onSelectionChange)="onDepartmentCodeSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-4" [hidden]="!this.action.reviewedByUser">
          <div>
            <label for="email">
              <!-- Reviewer -->{{dynamicLabel['REVIEWER'].fieldName}}
            </label>
            <label *ngIf="message.showSwitchUser && visibleEditButton" for="email"
              (click)="openswitchuser('Action Reviewer')" (keydown.enter)="openswitchuser('Action Reviewer')">
              <a>
                <img title="Switch User" src="..//..//../assets/img/user-switch.png" width="25" height="25"
                  alt="switch">
              </a></label>
            <span style="float:right" *ngIf="dynamicLabel['REVIEWER'].fieldNotes"
              [matTooltip]="dynamicLabel['REVIEWER'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>

          <mat-select matInput placeholder="Select" [(ngModel)]="searchingByReviewUser" (closed)="reviewUserTxt=''"
            (click)="focusmethod('reviewUserSearch')" [disabled]="true"
            [ngClass]="{'odd-item-mat-select':isreviewUserOdd==searchingByReviewUser}"
            (keydown.enter)="focusmethod('reviewUserSearch')">
            <input type="search" id="reviewUserSearch" class="dropdownsearchstyle" [(ngModel)]="reviewUserTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of listOfReviewerUsersDropdown| assessmentSearch :reviewUserTxt"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-4" [hidden]="!this.action.approvedByUser">
          <div><label for="email">
              <!-- Approver -->{{dynamicLabel['APPROVER'].fieldName}}
            </label>
            <label *ngIf="message.showSwitchUser && visibleEditButton" for="email"
              (click)="openswitchuser('Action Approver')" (keydown.enter)="openswitchuser('Action Approver')">
              <a>
                <img title="Switch User" src="..//..//../assets/img/user-switch.png" width="25" height="25"
                  alt="switch">
              </a> </label>
            <span style="float:right" *ngIf="dynamicLabel['APPROVER'].fieldNotes"
              [matTooltip]="dynamicLabel['APPROVER'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="searchingByApproveUser"
            (closed)="approveUserUserTxt=''" (click)="focusmethod('approveUserUserSearch')"
            (keydown.enter)="focusmethod('approveUserUserSearch')" [disabled]="true"
            [ngClass]="{'odd-item-mat-select':isapproveUserUserOdd==searchingByApproveUser}">
            <input type="search" id="approveUserUserSearch" class="dropdownsearchstyle" [(ngModel)]="approveUserUserTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of listOfApproverUsersDropdown| assessmentSearch :approveUserUserTxt"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-4" [hidden]="!this.action.deferReviewedByUser">
          <div><label for="email">
              <!-- Defer Reviewer -->{{dynamicLabel['DEFER_REVIEWER'].fieldName}}
            </label>
            <label *ngIf="message.showSwitchUser && visibleEditButton" for="email"
              (click)="openswitchuser('Action Defer Reviewer')"
              (keydown.enter)="openswitchuser('Action Defer Reviewer')">
              <a>
                <img title="Switch User" src="..//..//../assets/img/user-switch.png" width="25" height="25"
                  alt="switch">
              </a></label>
            <span style="float:right" *ngIf="dynamicLabel['DEFER_REVIEWER'].fieldNotes"
              [matTooltip]="dynamicLabel['DEFER_REVIEWER'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>

          <mat-select [ngClass]="{'odd-item-mat-select': oddDeferReviewer == searchingByDeferReviewUser}" matInput
            placeholder="Select" [(ngModel)]="searchingByDeferReviewUser" (closed)="deferReviewUserTxt=''"
            (click)="focusmethod('deferReviewUserSearch')" (keydown.enter)="focusmethod('deferReviewUserSearch')"
            [disabled]="true">
            <input type="search" id="deferReviewUserSearch" class="dropdownsearchstyle" [(ngModel)]="deferReviewUserTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of listOfDeferredReviewerUsersDropdown| assessmentSearch :deferReviewUserTxt"
              (onSelectionChange)="onReviewByUserSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-4" [hidden]="!this.action.deferApprovedByUser">
          <div>
            <label for="email">
              <!-- Defer Approver -->{{dynamicLabel['DEFER_APPROVER'].fieldName}}
            </label>
            <label *ngIf="message.showSwitchUser && visibleEditButton" for="email"
              (click)="openswitchuser('Action Defer Approver')"
              (keydown.enter)="openswitchuser('Action Defer Approver')">
              <a>
                <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="switch" width="25" height="25"
                  alt="switch">
              </a>
            </label>
            <span style="float:right" *ngIf="dynamicLabel['DEFER_APPROVER'].fieldNotes"
              [matTooltip]="dynamicLabel['DEFER_APPROVER'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <mat-select [ngClass]="{'odd-item-mat-select': oddDeferApprover == searchingByDeferApproveUser}" matInput
            placeholder="Select" [(ngModel)]="searchingByDeferApproveUser" (closed)="deferApproveUserTxt=''"
            (click)="focusmethod('defeApproveUserSearch')" (keydown.enter)="focusmethod('defeApproveUserSearch')"
            [disabled]="true">
            <input type="search" id="defeApproveUserSearch" class="dropdownsearchstyle"
              [(ngModel)]="deferApproveUserTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of listOfDeferredApproverUsersDropdown| assessmentSearch :deferApproveUserTxt"
              (onSelectionChange)="onApproveByUserSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-2"
          *ngIf="visibleEditButton && ((action.status == 'Open' && qmsservice.activity.status =='In Progress' ) || action.status != 'Open')">
          <div>
            <label for="email">
              <!-- Action Performed -->{{dynamicLabel['ACTION_PERFORMED'].fieldName}}
            </label>
            <span style="float:right" *ngIf="dynamicLabel['ACTION_PERFORMED'].fieldNotes"
              [matTooltip]="dynamicLabel['ACTION_PERFORMED'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <mat-slide-toggle color="primary" [(ngModel)]="action.actionPerformed">
            <span class="active-inActive-container" *ngIf="action.actionPerformed==true"
              [ngStyle]="action.actionPerformed==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
            <span *ngIf="action.actionPerformed==false"
              [ngStyle]="action.actionPerformed==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-4" *ngIf="action.actionPerformed && visibleEditButton">
          <div>
            <label id="performedActionDetails-validation" for="email">
              {{dynamicLabel['PERFORMED_ACTION_DETAILS'].fieldName}}
            </label>
            <span class="mandatory-symbol">*</span>
            <span style="float:right" *ngIf="dynamicLabel['PERFORMED_ACTION_DETAILS'].fieldNotes"
              [matTooltip]="dynamicLabel['PERFORMED_ACTION_DETAILS'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>

          <div class="row d-flex align-items-center">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="action.performedActionDetails" [config]="config"
                style="min-height: 100px !important;" [spellcheck]="true" (paste)="onPaste($event)"
                (focusout)="onFieldFocusout()">
              </st-editor>
            </div>

            <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Performed Action Details', 'edit','action')"
              (keydown.enter)="openEditor('Performed Action Details', 'edit','action')">
              <i class="far fa-edit"></i>
            </div>
          </div>
        </div>
        <div class="col-md-4"
          *ngIf="action.actionPerformed && visibleEditButton && dynamicLabel['JUSTIFICATION'].isRemovable != 'Y'">
          <!-- Additional Remark -->
          <div>
            <label id="justification-validation" for="email">{{dynamicLabel['JUSTIFICATION'].fieldName}}</label>
            <span style="float:right" *ngIf="dynamicLabel['JUSTIFICATION'].fieldNotes"
              [matTooltip]="dynamicLabel['JUSTIFICATION'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <textarea type="text" class="input-filed-textarea" rows="3" cols="50"
            [(ngModel)]="action.justification"></textarea>
        </div>
        <div class="col-md-2" [hidden]="!(action.actionPerformed && visibleEditButton)">
          <label id="actualActionCompletedOn-validation" for="email">
            {{dynamicLabel['ACTUAL_ACTION_COMPLETED_ON'].fieldName}}
          </label>
          <span style="float:right" *ngIf="dynamicLabel['ACTUAL_ACTION_COMPLETED_ON'].fieldNotes"
            [matTooltip]="dynamicLabel['ACTUAL_ACTION_COMPLETED_ON'].fieldNotes">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
          </span>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="$getDynamicConfig()"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="action.actualActionCompletedOn">
        </div>

        <div class="col-md-2" *ngIf="action.actionCompletedOn">
          <label id="actionCompletedOn-validation" for="email"> {{dynamicLabel['ACTION_COMPLETED_ON'].fieldName}}
          </label>
          <span style="float:right" *ngIf="dynamicLabel['ACTION_COMPLETED_ON'].fieldNotes"
            [matTooltip]="dynamicLabel['ACTION_COMPLETED_ON'].fieldNotes">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
          </span>
          <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="$dateTimeConfig"
            [dateCustomClasses]="dateCustomClasses" [(ngModel)]="action.actionCompletedOn" [disabled]="true">
        </div>
        <div class="col-md-2"
          [hidden]="dynamicLabel['REVIEW_REQUESTED_ON'].isRemovable == 'Y' || !action.reviewRequestedOn">
          <div><label for="email">
              <!-- Review Requested On -->{{dynamicLabel['REVIEW_REQUESTED_ON'].fieldName}}
            </label>
            <span style="float:right" *ngIf="dynamicLabel['REVIEW_REQUESTED_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['REVIEW_REQUESTED_ON'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <div class="px-2 input-filed-continers" style="align-content: center;">
            {{action.reviewRequestedOn |date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}</div>

        </div>
        <div class="col-md-2"
          [hidden]="dynamicLabel['REVIEW_COMPLETED_ON'].isRemovable == 'Y' || !action.reviewCompletedOn">
          <div><label for="email">
              <!-- Review Completed On -->{{dynamicLabel['REVIEW_COMPLETED_ON'].fieldName}}
            </label>
            <span style="float:right" *ngIf="dynamicLabel['REVIEW_COMPLETED_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['REVIEW_COMPLETED_ON'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <div class="px-2 input-filed-continers" style="align-content: center;">
            {{action.reviewCompletedOn |date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}</div>
        </div>
        <div class="col-md-6" [hidden]="dynamicLabel['REVIEW_COMMENTS'].isRemovable == 'Y' || !action.reviewComments">
          <!-- Review Comments -->
          <div>
            <label for="email">{{dynamicLabel['REVIEW_COMMENTS'].fieldName}}</label>
            <span style="float:right" *ngIf="dynamicLabel['REVIEW_COMMENTS'].fieldNotes"
              [matTooltip]="dynamicLabel['REVIEW_COMMENTS'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <textarea type="text" class="input-filed-textarea" rows="3" cols="50" [(ngModel)]="action.reviewComments"
            disabled></textarea>
        </div>
        <div class="col-md-2"
          [hidden]="dynamicLabel['APPROVAL_REQUESTED_ON'].isRemovable == 'Y' || !action.approvalRequestedOn">
          <!-- Approval Requested On -->
          <div>
            <label for="email">{{dynamicLabel['APPROVAL_REQUESTED_ON'].fieldName}}</label>
            <span style="float:right" *ngIf="dynamicLabel['APPROVAL_REQUESTED_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['APPROVAL_REQUESTED_ON'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <div class="px-2 input-filed-continers" style="align-content: center;">{{action.approvalRequestedOn |
            date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}</div>
        </div>
        <div class="col-md-2"
          [hidden]="dynamicLabel['APPROVAL_COMPLETED_ON'].isRemovable == 'Y' || !action.approvalCompletedOn">
          <!-- Approval Completed On -->
          <div>
            <label for="email">{{dynamicLabel['APPROVAL_COMPLETED_ON'].fieldName}}</label>
            <span style="float:right" *ngIf="dynamicLabel['APPROVAL_COMPLETED_ON'].fieldNotes"
              [matTooltip]="dynamicLabel['APPROVAL_COMPLETED_ON'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <div class="px-2 input-filed-continers" style="align-content: center;">{{action.approvalCompletedOn
            |date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}</div>
        </div>
        <div class="col-md-6"
          [hidden]="dynamicLabel['APPROVAL_COMMENTS'].isRemovable == 'Y' || !action.approvalComments">
          <!-- Approval Comments -->
          <div>
            <label for="email">{{dynamicLabel['APPROVAL_COMMENTS'].fieldName}}</label>
            <span style="float:right" *ngIf="dynamicLabel['APPROVAL_COMMENTS'].fieldNotes"
              [matTooltip]="dynamicLabel['APPROVAL_COMMENTS'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <textarea type="text" class="input-filed-textarea" rows="3" cols="50" [(ngModel)]="action.approvalComments"
            disabled></textarea>
        </div>
        <div class="col-md-4" [hidden]="dynamicLabel['DEFER_REASON'].isRemovable == 'Y' || !action.deferReason">
          <!-- Review Comments -->
          <div>
            <label for="email">{{dynamicLabel['DEFER_REASON'].fieldName}}</label>
            <span style="float:right" *ngIf="dynamicLabel['DEFER_REASON'].fieldNotes"
              [matTooltip]="dynamicLabel['DEFER_REASON'].fieldNotes">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </span>
          </div>
          <textarea type="text" class="input-filed-textarea" rows="3" cols="50" [(ngModel)]="action.deferReason"
            disabled></textarea>
        </div>
      </div>

      <div mat-dialog-actions class="btn-align">
        <div class="button-continer" *ngFor="let button of buttonList" style="margin-left: 10px;">
          <button *ngIf="button == 'Cancel' && button != '' " mat-stroked-button class="cancelButton"
            (click)="cancelAddAndEditFunction()">
            {{button}}</button>
          <button *ngIf="button == 'Save' && button != ''" mat-stroked-button class="addButton"
            (click)="addAndEditFunction()">
            {{button}}</button>
          <button *ngIf="button != 'Cancel' && button != '' && button != 'Save' " mat-stroked-button class="addButton"
            (click)="dynamicButtonClick(button)"> {{button}}</button>
        </div>
      </div>

      <div class="form-template ActivityPage" *ngIf="this.visibleEditButton" id="Documents" style="margin-top:1%;">
        <div class="menu-container">
          <div class="row menu-row-container">
            <div class="col-sm-6 gridName-container">
              <span class="gridName">Documents</span>
            </div>
          </div>
        </div>
        <app-task-documents [activity]="this.objForDocuments"></app-task-documents>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #confirmWithReasonPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelFunc()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ buttonLabel }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span></label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="">
      <div class="row px-3">
        <div class="col-sm-12" *ngIf="buttonLabel =='Review'|| buttonLabel ==='Approve'">
          <div><label id="reviewAndapprove-validation" for="email">{{buttonLabel}}</label><span
              class="mandatory-symbol">*</span></div>
          <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedStatus">
            <mat-radio-button class="tp-radio-button" *ngFor="let status of reviewStatus" [value]="status"
              (change)="radioChange($event)">
              {{status}}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="col-md-12 fieldStyle3" *ngIf="isEsignRequired">
          <div class=""><label for="username ">User Name</label><span class="mandatory-symbol">*</span></div>
          <div class=""> <input id="username" style="height: 80% !important;" class="input-filed-continers" type="text"
              [(ngModel)]="userName" disabled></div>
        </div>
        <div class="col-md-12" *ngIf="(isEsignRequired && !isAdenabled)">
          <div class=""><label id="password-validation" for="pass ">Password</label><span
              class="mandatory-symbol">*</span></div>
          <div class=""> <input id="EsignRequiredPassword" autocomplete="off" onpaste="return false;"
              ondrop="return false;" style="height: 80% !important;" class="input-filed-continers"
              [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste>
            <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
              <i
                [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
            </span>
          </div>
        </div>
        <div class="col-md-12"
          *ngIf="(this.buttonLabel=='Submit for Review' || this.buttonLabel=='Submit for Approval') && this.action.reviewedByUser!=0">
          <div>
            <label for="email">
              Reviewer<!-- {{dynamicLabel['REVIEWER']}} -->
            </label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="searchingByReviewUser" (closed)="reviewUserTxt1=''"
            (click)="focusmethod('reviewer')" (keydown.enter)="focusmethod('reviewer')">
            <input type="search" id="reviewer" class="dropdownsearchstyle" [(ngModel)]="reviewUserTxt1" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of listOfReviewerUsersDropdown| assessmentSearch :reviewUserTxt1"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-12"
          *ngIf="(this.buttonLabel=='Submit for Review' || this.buttonLabel=='Submit for Approval') && this.action.approvedByUser!=0">
          <div><label for="email">
              Approver <!--{{dynamicLabel['APPROVER']}} -->
            </label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="searchingByApproveUser"
            (closed)="approveUserUserTxt1=''" (click)="focusmethod('approver')"
            (keydown.enter)="focusmethod('approver')">
            <input type="search" id="approver" class="dropdownsearchstyle" [(ngModel)]="approveUserUserTxt1" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of listOfApproverUsersDropdown| assessmentSearch :approveUserUserTxt1"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="mt-2" [ngStyle]="{'border': buttonLabel=='Defer Action' ? '1px solid #cfcfcf' : '' }">
          <div class="col-md-12" *ngIf="buttonLabel=='Defer Action'">
            <div><label id="reviewUser-validation" for="email">
                Defer Reviewer
              </label><span class="mandatory-symbol">*</span></div>
            <mat-select matInput placeholder="Select"
              [ngClass]="{'odd-item-mat-select': oddDeferReviewer == searchingByDeferReviewUser}"
              [(ngModel)]="searchingByDeferReviewUser" (closed)="deferReviewUserTxt1=''"
              (click)="focusmethod('defer-reviewer')" (keydown.enter)="focusmethod('defer-reviewer')">
              <input type="search" id="defer-reviewer" class="dropdownsearchstyle" [(ngModel)]="deferReviewUserTxt1"
                matInput placeholder="search">
              <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
              <mat-option
                *ngFor="let item of listOfDeferredReviewerUsersDropdown| assessmentSearch :deferReviewUserTxt1"
                (onSelectionChange)="onReviewByUserSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-12" *ngIf="buttonLabel=='Defer Action'">
            <div><label id="approverUser-validation" for="email">
                Defer Approver <!-- {{dynamicLabel['Defer Approver']}}-->
              </label><span class="mandatory-symbol">*</span></div>
            <mat-select matInput placeholder="Select"
              [ngClass]="{'odd-item-mat-select': oddDeferApprover == searchingByDeferApproveUser}"
              [(ngModel)]="searchingByDeferApproveUser" (closed)="deferApproveUserTxt1=''"
              (click)="focusmethod('defer-approver')" (keydown.enter)="focusmethod('defer-approver')">
              <input type="search" id="defer-approver" class="dropdownsearchstyle" [(ngModel)]="deferApproveUserTxt1"
                matInput placeholder="search">
              <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
              <mat-option
                *ngFor="let item of listOfDeferredApproverUsersDropdown| assessmentSearch :deferApproveUserTxt1"
                (onSelectionChange)="onApproveByUserSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-12"
            *ngIf="this.buttonLabel=='Review' || this.buttonLabel=='Approve'||buttonLabel=='Defer Action'">
            <div>
              <label id="reason-validation" for="reason">
                {{buttonLabel == 'Defer Action' ?'Defer Comments':'Comments' }}</label>
              <span class="mandatory-symbol" *ngIf="selectedStatus?.includes('Rejected')">*</span>
            </div>
            <textarea rows="4" class="input-filed-textarea" type="text" [(ngModel)]="reason"></textarea>
          </div>
        </div>
        <!-- Deferred -->

      </div>
      <br>
      <br
        *ngIf="(this.buttonLabel=='Submit for Review' || this.buttonLabel=='Submit for Approval') && this.action.approvedByUser!=0">
    </div>
    <div class="button-continer btn-align" mat-dialog-actions
      [ngStyle]="buttonLabel=='Defer Action' || buttonLabel=='Review' || this.buttonLabel=='Approve'?{'margin-top':'10%'} : {'':''}">
      <button *ngIf="buttonLabel != 'Defer Action'" mat-stroked-button class="addButton"
        (click)="confirmWithReasonFunc()">
        {{buttonLabel}}
      </button>
      <button *ngIf="buttonLabel=='Defer Action'" mat-stroked-button class="addButton"
        (click)="confirmWithReasonFunc()">
        Submit
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmationPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeConfirmPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Confirmation</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span></label>
  </div>
  <div style="margin: 15px 15px;">
    <p><strong style="display: flex; justify-content: center; align-items: center;">{{ confirmationMessage }}</strong>
    </p>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="confirmYes()">Proceed</button>
      <button mat-stroked-button class="cancelButton" (click)="closeConfirmPopup()">Cancel</button>
    </div>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label id="deleteReason-validation" for="email">Reason for Delete</label><span
              class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea" type="text" class="input-filed-textarea uppercase" rows="4" cols="50"
            [(ngModel)]="action.deleteReason" (focusout)="onFieldFocusout()"></textarea>
        </div>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction(action)">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmValidationPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelValidationConfirmFunc()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ buttonLabel }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <h3>You have either not performed the action or uploaded the supporting Documents.</h3>
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="cancelButton" (click)="cancelValidationConfirmFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #editor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelEditor()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ editorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div><br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]=" allowEditing ? includeButtons : excludeButtons"
        [spellcheck]="true" (paste)="onPaste($event)"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" *ngIf="allowEditing" (click)="saveEditor(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #reorderPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>

  <button class="close close-button" (click)="cancelReorder()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle">Actions Reorder</label>
    <label for="title" class="popupAppTitle">One<span style="color:gold;">QMS</span></label>
  </div>

  <div style="margin: 15px 15px;">
    <b class="align-center">
      Drag and drop to reorder the Actions
    </b>

    <div class="table-container">
      <table style="max-height: 65vh;">
        <thead>
          <th class="control-text" style="width: 120px; text-align: center;">
            Current Seq.
          </th>
          <th class="control-text" style="width: 300px; text-align: left;">
            Action Name
          </th>
          <th class="control-text" style="width: 120px; text-align: center;">
            New Seq.
          </th>
        </thead>

        <tbody cdkDropList (cdkDropListDropped)="dragAndDrop($event)">
          <tr cdkDrag cdkDragLockAxis="y" *ngFor="let row of grid; let i = index;">
            <td class="control-text" style="text-align: center;">
              {{ row.SL_NO }}
            </td>
            <td class="control-text" style="text-align: left;">
              {{ row.ACTION_NAME }}
            </td>
            <td class="control-text" style="text-align: center;">
              {{ row.NEW_ORDER }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="reorderActions()" [disabled]="!isReordered">
        <i class="fa fa-redorder"></i> Reorder
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelReorder()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>


<app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()"></app-switchuser>
<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-editor #clobViewPopup></app-editor>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmit()"></app-grid-reorder>
<app-search-users (valueEmitter)="onSearchUserEmitted()"></app-search-users>
